const CardIcon = ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{marginRight:10}}
      className={className}
    >
      <path
        d="M18.3337 4.99992V14.9999C18.3337 15.4583 18.1705 15.8506 17.8441 16.177C17.5177 16.5034 17.1253 16.6666 16.667 16.6666H3.33366C2.87533 16.6666 2.48296 16.5034 2.15658 16.177C1.83019 15.8506 1.66699 15.4583 1.66699 14.9999V4.99992C1.66699 4.54159 1.83019 4.14922 2.15658 3.82284C2.48296 3.49645 2.87533 3.33325 3.33366 3.33325H16.667C17.1253 3.33325 17.5177 3.49645 17.8441 3.82284C18.1705 4.14922 18.3337 4.54159 18.3337 4.99992ZM3.33366 6.66658H16.667V4.99992H3.33366V6.66658ZM3.33366 9.99992V14.9999H16.667V9.99992H3.33366Z"
        fill="currentColor"
      />
    </svg>
  );
  
  export default CardIcon;
  